import React from 'react';
import ReactDOM from 'react-dom/client';
// antd.variable.min.css lets the theme set antd colors at runtime
import 'antd/dist/antd.variable.min.css';
import './index.css';
import './theme/theme.css';
import { applyTheme } from './theme/theme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from "react-query"
import { Provider } from 'react-redux';
import store from './redux/store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      refetchOnReconnect: false
    },
  },
})

// White label: colors, logos, title, favicon from src/theme/theme.js
applyTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
